import { provideCommonAuthService } from '@invivodf/front-seller-auth/src/useAuth'
import { provideAuthService, useAuthService } from '@b2ag/auth'
import { SELLER_SCOPES } from '@invivodf/front-seller-auth/src/SELLER_SCOPES'
import { BRAND_MANAGE_SCOPES } from '@invivodf/front-seller-auth/src/BRAND_MANAGE_SCOPES'
import { PRODUCT_MANAGER_MANAGE_SCOPES } from '@invivodf/front-seller-auth/src/PRODUCT_MANAGER_MANAGE_SCOPES'
import { discountPermissions } from '@invivodf/common/src/contexts/discount/application/routes/discount-permissions'
import { provideScopesService } from '@/auth'

// Requested, but kept out of SELLER_SCOPES, the scopes validated on every navigation.
const REQUESTED_SCOPES = [
  ...SELLER_SCOPES,
  ...discountPermissions,
  ...BRAND_MANAGE_SCOPES,
  ...PRODUCT_MANAGER_MANAGE_SCOPES,
]

// B2ag: Auth0 via @b2ag/auth, common auth port backed by it, seller scopes.
export async function bootstrapB2agAuth(): Promise<void> {
  const extraConfig: any = {
    extranetConnection: window.env.AUTH0_EXTRANET_CONNECTION,
    smagConnection: window.env.AUTH0_SMAG_CONNECTION,
  }

  await provideAuthService({
    audience: window.env.AUTH0_AUDIENCE!,
    domain: window.env.AUTH0_DOMAIN!,
    redirectUri: `${window.location.origin}/oauth/callback`,
    authority: window.env.AUTH0_DOMAIN!,
    clientId: window.env.AUTH0_CLIENT_ID!,
    requiredScopes: REQUESTED_SCOPES,
    ...extraConfig,
  })

  provideCommonAuthService({
    getAccessToken: () => useAuthService().getAccessToken(),
    getUserScopes: async () => (await useAuthService().getScopes()) || [],
  })

  provideScopesService(SELLER_SCOPES)
}
